var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"justify-center",attrs:{"height":"88"}},[_c('social-media',{attrs:{"large":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }